import useModalRoute from '@/hooks/useModalRoute';
import modalService from '@/services/modal/modalService';

import ExperienceScoreDetailedInsightModal from './ExperienceScore/ExperienceScoreDetailedInsightModal';
import ExperienceScoreInfoModal from './ExperienceScore/ExperienceScoreInfoModal';

/** Always mounted - open/insightId/code are derived from the URL so native back animates the close. */
const ModalsRoot = () => {
    const {insightId, isDetailOpen, infoCode, isInfoOpen} = useModalRoute();

    return (
        <>
            <ExperienceScoreDetailedInsightModal
                open={isDetailOpen}
                insightId={insightId}
                onClose={modalService.closeTop}
            />
            <ExperienceScoreInfoModal open={isInfoOpen} code={infoCode} onClose={modalService.closeTop} />
        </>
    );
};

export default ModalsRoot;
